var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.554,
    height: 19.555,
    viewBox: "0 0 19.554 19.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "messenger",
    transform: "translate(-.001 -.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M19.553 9.384A9.6 9.6 0 0 0 9.777 0 9.6 9.6 0 0 0 0 9.383V9.4a9.229 9.229 0 0 0 3.068 6.823v2.364a.958.958 0 0 0 .958.971.952.952 0 0 0 .506-.146l1.9-1.187a10.036 10.036 0 0 0 3.326.565h.202a9.6 9.6 0 0 0 9.593-9.38v-.026zm-3.753 5.91a8.4 8.4 0 0 1-5.845 2.35H9.776a8.9 8.9 0 0 1-3.091-.544.834.834 0 0 0-.734.075l-1.736 1.082v-2.174a.84.84 0 0 0-.289-.633A8.08 8.08 0 0 1 1.147 9.4a8.454 8.454 0 0 1 8.618-8.25h.023a8.454 8.454 0 0 1 8.618 8.25 8.4 8.4 0 0 1-2.606 5.894zm0 0",
    className: "cls-1",
    "data-name": "Path 58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M92.338 160.814L88.7 162.8l-2.181-1.87a.961.961 0 0 0-1.3.05l-4.6 4.6a.958.958 0 0 0 .677 1.633.962.962 0 0 0 .459-.118l3.641-1.985 2.183 1.871a.961.961 0 0 0 1.3-.05l4.6-4.6a.958.958 0 0 0-1.139-1.515zM88.186 166l-2.211-1.9a.843.843 0 0 0-.946-.1l-2.67 1.455 3.544-3.544 2.209 1.894a.843.843 0 0 0 .947.1l2.676-1.459zm0 0",
    className: "cls-1",
    "data-name": "Path 59",
    transform: "translate(-77.267 -154.56)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.60b947a9.svg";
export { ForwardRef as ReactComponent };